module.exports = __webpack_public_path__ + "img/intro-img.2586459b.svg";